/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from 'vant';
import { ubtPageButton } from '@/shared/utils/ubt';
import { RouterV2Enum } from '@/router/router-names';

const style = require('./index.module.scss');
const closeIcon = require('./image/close.png');
const interstIcon = require('./image/interest.png');

@Component({ name: 'InterestFree' })
export default class InterestFree extends Vue {
  @Prop(String)
  private commodityId!: string;

  @Prop({ default: '首期免息券' })
  private couponTitle!: string;

  @Prop({ default: true })
  private couponTip!: boolean;

  private dialogShow = true;

  private onClosed() {
    this.$emit('close');
  }

  // 立即提现
  private onSubmit() {
    ubtPageButton(this, '臻有钱_首提活动弹窗_立即提现');

    this.$router.push({
      path: RouterV2Enum.applyProduct,
      query: {
        commodityId: this.commodityId,
        from: this.$route.path,
      },
    });
  }

  private render() {
    return (
      <div class={style.InterestFree}>
        <van-dialog v-model={this.dialogShow} show-confirm-button={false}>
          <div class={style.main}>
            <img src={interstIcon} />
            <div class={style.content}>
              <span>您已获得</span>
              <span>{this.couponTitle}</span>
              {this.couponTip && <p>提现后完成首期还款返红包</p>}
            </div>
          </div>
          <div class={style.footer}>
            <Button
              type="primary"
              size="large"
              class={style.dialogSubmit}
              onClick={this.onSubmit.bind(this)}
            >
              立即提现
            </Button>
            <img src={closeIcon} class={style.closed} onClick={this.onClosed.bind(this)} />
          </div>
        </van-dialog>
      </div>
    );
  }
}
